import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchEmployeeContacts as getDirectContactApi,
  fetchChannels as getChannelsApi,
  fetchMessages as getMessagesApi,
  createMessage as addMessageApi,
  removeMessage as deleteMessageApi
} from "../../utils/message";

// Fetch contacts
export const getDirectContact = createAsyncThunk("chat/getDirectContact", async () => {
  try {
    const response = await getDirectContactApi();
    return response;
  } catch (error) {
    throw error;
  }
});

// Fetch channels
export const getChannels = createAsyncThunk("chat/getChannels", async () => {
  try {
    const response = await getChannelsApi();
    return response;
  } catch (error) {
    throw error;
  }
});

// Fetch messages for a room
export const getMessages = createAsyncThunk("chat/getMessages", async (roomId) => {
  try {
    const response = await getMessagesApi(roomId);
    return response;
  } catch (error) {
    throw error;
  }
});

// Send a new message
export const addMessage = createAsyncThunk("chat/addMessage", async (message) => {
  try {
    const response = await addMessageApi(message);
    return response;
  } catch (error) {
    throw error;
  }
});

// Delete a message
export const deleteMessage = createAsyncThunk("chat/deleteMessage", async (messageId) => {
  try {
    const response = await deleteMessageApi(messageId);
    return response;
  } catch (error) {
    throw error;
  }
});
